import React from "react";

const A = ( props ) => {

  const {
    onClick,
    children,
    ...PROPS
  } = props;

  const click = ( event ) => {
    onClick( event );
    event.preventDefault();
  };

  return <a href="#" onClick={ click } { ...PROPS }>{ children }</a>;

};

A.defaultProps = {
  onClick : () => {}
};

export default A;
